/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BlendBridge } from 'blb-types/blendBridge';
export const generateTaskDescriptionKey = taskDescription => {
  if (taskDescription.key) return taskDescription.key;
  switch (taskDescription.type) {
    case BlendBridge.API.TaskDescriptionTypes.CHECKBOX:
      return taskDescription.label;
    case BlendBridge.API.TaskDescriptionTypes.LABEL:
      return taskDescription.label;
    case BlendBridge.API.TaskDescriptionTypes.FILE_INPUT:
      return taskDescription.label;
    case BlendBridge.API.TaskDescriptionTypes.TEXT:
      return taskDescription.description;
    case BlendBridge.API.TaskDescriptionTypes.INPUT:
      return taskDescription.promptText;
    default:
      return '';
  }
};